export var SCREEN_READER_MESSAGE_ID = 'date-picker-sr-message';
export var DAY_INDEX_REMAPPING = {
  0: 6,
  1: 0,
  2: 1,
  3: 2,
  4: 3,
  5: 4,
  6: 5
};